/**
 * Created by toomasp on 10.08.2015.
 */
"use strict";

function generateKey(label) {
    return label.replace(/[\.,-\/#!$%\^&\*;:{}=\-_`~()]/g, '');
}

function createHeaders(headerLabelCodes) {
    var headers = [];
    headerLabelCodes.forEach(function (label) {
        headers.push({
            label: label,
            key: generateKey(label)
        });
    });
    return headers;
}

class SimpleTable {
    constructor(headerLabelCodes, buttonHandler, pager) {
        this.headers = createHeaders(headerLabelCodes);
        this.columns = [];
        this.buttonHandler = buttonHandler;
        this.orderField = '';
        this.pager = pager;
    }

    clearColumns = function () {
        this.columns.splice(0);
    }

    addColumn = function (arrayOfValues, properties) {
        if (!(arrayOfValues instanceof Array)) {
            throw 'Only arrays can be columns';
        }

        var column = {};
        var i;

        for (i = 0; i < this.headers.length; i++) {
            column[this.headers[i].key] = arrayOfValues[i];
        }
        // Additional internal data
        column._properties = properties;

        this.columns.push(column);
    }

    setOrderBy = function (label, order) {
        var orderPrefix = order && order === 'desc' ? '-' : '';
        this.orderField = orderPrefix + generateKey(label);
    }
}

class SimpleTableFactory {
    create(headerLabelCodes, buttonHandler, pager) {
        if (!headerLabelCodes || !(headerLabelCodes instanceof Array)) {
            throw 'Headers must be provided';
        }
        return new SimpleTable(headerLabelCodes, buttonHandler, pager);
    }
}

export default SimpleTableFactory;


// WEBPACK FOOTER //
// ./src/ui/core/common/directives/widget/table/simple-table.model.js